"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWallSyncBuilder = exports.UserWallSyncBuilder = void 0;
const sdk_streem_wall_1 = require("@streem/sdk-streem-wall");
const sdk_twilio_wall_1 = require("@streem/sdk-twilio-wall");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
const wall_token_util_1 = __importDefault(require("./wall_token_util"));
class WallSyncBuilder {
    constructor(wallItemClass, connectionId, wallId) {
        this.wallItemClass = wallItemClass;
        this.connectionId = connectionId;
        this.wallId = wallId;
    }
    build() {
        return __awaiter(this, void 0, void 0, function* () {
            const creds = yield this.fetchCreds();
            const syncOpts = {
                wallId: this.wallId,
                initialCreds: creds,
                refreshToken: this.fetchCreds.bind(this),
                onDisconnect: this.disconnect,
                connectionId: this.connectionId,
            };
            logger_1.logger.info(`${this.constructor.name} initializing ${creds.syncService}WallSync.`);
            if (creds.syncService === 'twilio') {
                return new sdk_twilio_wall_1.TwilioWallSync(this.wallItemClass, syncOpts);
            }
            else {
                return new sdk_streem_wall_1.StreemWallSync(this.wallItemClass, syncOpts);
            }
        });
    }
}
class UserWallSyncBuilder extends WallSyncBuilder {
    constructor(userId, connectionId) {
        super(streem_sdk_protobuf_1.streem.user.UserWallItem, connectionId.toString(), userId.toString());
        this.userId = userId;
    }
    fetchCreds() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                logger_1.logger.info(`UserWallSync refreshing Token.`);
                yield wall_token_util_1.default.userClientCred.fetch(this.userId);
                return wall_token_util_1.default.userClientCred.getWallCreds();
            }
            catch (e) {
                logger_1.logger.error(`UserWallSync failed to refresh room wall credentials`, e);
                throw e;
            }
        });
    }
    disconnect() {
        wall_token_util_1.default.userClientCred.disconnect();
        logger_1.logger.info('UserWallSync disconnected.');
    }
}
exports.UserWallSyncBuilder = UserWallSyncBuilder;
class RoomWallSyncBuilder extends WallSyncBuilder {
    constructor(roomId, connectionId, userId, readOnly) {
        super(streem_sdk_protobuf_1.WallItem, connectionId.toString(), roomId.toString());
        this.roomId = roomId;
        this.userId = userId;
        this.readOnly = readOnly;
    }
    fetchCreds() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                logger_1.logger.info(`RoomWallSync refreshing Token.`);
                yield wall_token_util_1.default.roomWallClientCred.fetch(this.roomId, this.userId, this.readOnly);
                const roomWallCredentials = wall_token_util_1.default.roomWallClientCred.getWallCreds();
                return roomWallCredentials;
            }
            catch (e) {
                logger_1.logger.error(`RoomWallSync failed to refresh room wall credentials`, e);
                throw e;
            }
        });
    }
    disconnect() {
        wall_token_util_1.default.roomWallClientCred.disconnect();
        logger_1.logger.info('RoomWallSync disconnected.');
    }
}
exports.RoomWallSyncBuilder = RoomWallSyncBuilder;
//# sourceMappingURL=wall_sync_builder.js.map